<div [ngClass]="uiClass">
    <button class="button-wrapper" type="button" (click)="onBookmarkClick(programId, isFavourite)">
        <mat-icon class="custom-icon" [ngClass]="[isFavourite ? 'text-[#E73A3A]' : 'text-[#859296]']">
            favorite
        </mat-icon>
    </button>
</div>
